import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/theme.css"; // pink + black theme
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker to enable PWA functionality
serviceWorkerRegistration.register();
